<template>
  <div class=" flex justify-center">
    <div class="ticket-card bg-gray-100 shadow-md rounded-lg hover:scale-105 transform transition duration-300 w-full">

      <!-- Top Section -->
      <div class="top rounded-t-lg flex flex-col items-center">
        <div class="text-2xl font-bold pt-4">{{ event.name }}</div>
        <div class="text-gray-500" v-if="event.excerpt">{{ event.excerpt }}</div>
        <img :src="event.image.medium" alt="Event Image" class="w-full my-4">
        <div class="deetz flex justify-between w-full px-3 pt-2 pb-6">
          <div class="event flex flex-col">
            <div class="date text-gray-400">{{ formattedDate }}</div>
            <div v-if="event.info.address" class="location font-bold">{{ formattedAddress }}</div>
          </div>
          <div class="price flex flex-col text-right">
            <div class="label text-gray-500">{{ $translate('Ticket Price') }}</div>
            <div class="cost text-3xl text-blue-500 font-bold">{{ event.price.formatted }}</div>
            <div v-if="event.price.is_discounted" class="text-sm text-red-500 line-through">{{
              event.price.original_price_formatted }}</div>
          </div>
        </div>
      </div>

      <!-- Rip Section -->

      <!-- Bottom Section -->
      <div
        class="bottom bg-gray-300 rounded-b-lg flex justify-between items-center p-4 relative
                  before:absolute before:content-[''] before:-left-3 before:top-0 before:w-6 before:h-6 before:bg-white before:rounded-full before:-translate-y-1/2
                  after:absolute after:content-[''] after:-right-3 after:top-0 after:w-6 after:h-6 after:bg-white after:rounded-full after:-translate-y-1/2">
        <div class="barcode w-24 h-8 bg-repeat-y bg-barcode-pattern"></div>
        <button @click="toggleTickets"
          class="buy-ticket bg-blue-500 text-white font-semibold py-2 px-4 rounded-full hover:bg-blue-600">
          {{ $translate('Add Ticket to Cart') }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>


export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  /*setup(props) {
    console.log(props.event);
  },*/
  computed: {
    isSingleDayEvent() {
      // Check if the start and end date are the same date (ignoring time)
      return new Date(this.event.info.date.start_at).toDateString() === new Date(this.event.info.date.end_at).toDateString();
    },
    formattedAddress() {
      if (!this.event.info.address) {
        return '';
      }
      //make sure only first two word from address will be useModel, if dash we add <br>
      return this.event.info.address.split(' ').slice(0, 4).join(' ');

    },
    formattedDate() {
      // Parse the date strings properly
      const startDate = new Date(this.event.info.date.start_at);
      const endDate = new Date(this.event.info.date.end_at);

      if (isNaN(startDate) || isNaN(endDate)) {
        console.error('Invalid date format:', this.event.info.date.start_at, this.event.info.date.end_at);
        return 'Invalid Date';
      }

      const dateOptions = { day: 'numeric', month: 'long' }; // Format with full month name
      const startDateStr = `${startDate.toLocaleDateString('cs-CZ', dateOptions)} ${this.formatTime(this.event.info.date.start_at)}`;
      const endDateStr = `${endDate.toLocaleDateString('cs-CZ', dateOptions)} ${this.formatTime(this.event.info.date.end_at)}`;

      if (this.isSingleDayEvent) {
        return `${startDateStr} - ${this.formatTime(this.event.info.date.end_at)}`;
      } else {
        return `${startDateStr} - ${endDateStr}`;
      }
    }
  },
  methods: {
    toggleTickets() {
      this.$emit('select', this.event);
    },
    formatTime(dateString) {
      const date = new Date(dateString);
      if (isNaN(date)) {
        console.error('Invalid time format:', dateString);
        return 'Invalid Time';
      }
      const options = { hour: '2-digit', minute: '2-digit' };
      return date.toLocaleTimeString('cs-CZ', options);
    },
  },
};
</script>

<style scoped>
.bottom {
  border-top: 3px dashed #a9a9a9;
}

.rip {
  position: relative;
}

.barcode {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAAABCAYAAABXChlMAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuOWwzfk4AAACPSURBVChTXVAJDsMgDOsrVpELiqb+/4c0DgStQ7JMYogNh2gdvg5VfXFCRIZaC6BOtnoNFpvaumNmwb/71Frrm8XvgYkker1/g9WzMOsohaOGNziRs5inDsAn8yEPengTapJ5bmdZ2Yv7VvfPN6AH2NJx7nOWPTf1/78hoqgxhzw3ZqYG1Dr/9ur3y8vMxgNZhcAUnR4xKgAAAABJRU5ErkJggg==');
}
</style>
